// One pause switch for every globe on the page (WCAG 2.2.2). The hero globe and
// the scroll stage each show a button; both read and write this one value, so a
// visitor who pauses once stops all background motion.
import { useSyncExternalStore } from 'react'

let paused = false
const listeners = new Set<() => void>()

export const globePause = {
  get: () => paused,
  set(next: boolean) {
    if (next === paused) return
    paused = next
    listeners.forEach((fn) => fn())
  },
  subscribe(fn: () => void) {
    listeners.add(fn)
    return () => {
      listeners.delete(fn)
    }
  },
}

export function useGlobePaused(): [boolean, (next: boolean) => void] {
  const value = useSyncExternalStore(globePause.subscribe, globePause.get, () => false)
  return [value, globePause.set]
}
